export abstract class IdNumberValidator<T = any> {
  abstract validate(params: T): boolean;
}
